import {
  GET_PATIENT_FILES_KEY,
  downloadPatientFile,
  downloadPatientFilesArchive,
  useGetPatientFiles,
} from './hook';

export const PatientFiles = {
  useGetPatientFiles,
  downloadPatientFile,
  downloadPatientFilesArchive,

  KEYS: {
    GET_PATIENT_FILES_KEY,
  },
};
